import { readEnvFile } from '@wix/cli-fs';
import { envSchema, getEnvFilePath } from '@wix/cli-astro-definitions';

export async function readEnv(projectFolder: string) {
  const raw = await readEnvFile(getEnvFilePath(projectFolder));
  const result = envSchema.safeParse(raw);
  return result.success ? result.data : {};
}
